import React, { useContext, useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { Filter, FilterOptions, SearchAppContext } from '../models/search-models';
import { addFilterByApp, removeFilterByApp } from '../slices/backend-search-slice';
import { filterAccordionStyles } from '../../global/constants/theme/styles/pages/search/search-filter-accordion';
import { searchPageStyles } from '../../global/constants/theme/styles/pages/search/search-page-layout';

export interface Props {
	filterType: string,
	filterTitle: string,
	filterHelperText: string,
	expand?: boolean,
}

export function CheckBoxFilter(props: Props) {
	const app = useContext(SearchAppContext);
	const dispatch = useDispatch();
	const [expand, setExpand] = useState(props?.expand);
	const filterOptions = useSelector<TcsmStates, FilterOptions>(state => state?.backendSearchStates[app]?.filterOptions[props?.filterType]);
	const selectedFilters = useSelector<TcsmStates, Filter[]>(state => state?.backendSearchStates[app]?.seletedFilters?.filter(f => f?.type === props.filterType));
	const [filteredOptions, setFilteredOptions] = useState(null);
	const [checked, setChecked] = useState({});
	const displayedOptions = filteredOptions || filterOptions?.options;
	const [searchValue, setSearchValue] = useState('');
	const accordionClasses = filterAccordionStyles();
	const searchClasses = searchPageStyles();

	useEffect(() => {
		setExpand(props?.expand);
	}, [props?.expand]);

	useEffect(() => {
		const updatedChecked = {};
		const keys = Object.keys(checked);
		keys.forEach(a => {
			updatedChecked[a] = selectedFilters?.some(s => s?.value === a);
		});
		setChecked(updatedChecked);
	}, [selectedFilters?.length]);

	const handleChange = (evt, value, display) => {
		const update = { ...checked, [value]: evt?.target?.checked };
		setChecked(update);
		if (evt?.target?.checked) {
			dispatch(addFilterByApp({ type: props?.filterType, value, display }, app));
		} else {
			dispatch(removeFilterByApp({ type: props?.filterType, value }, app));
		}
	};

	const onChange = (evt) => {
		setSearchValue(evt?.target?.value);
		const updatedOptions = filterOptions?.options?.filter(a => a?.value?.toLocaleLowerCase()?.includes(evt?.target?.value?.toLocaleLowerCase()));
		setFilteredOptions(updatedOptions);
	};

	return (
		<Accordion className={`${accordionClasses.filterAccordionitem} filter-accordion-item`} expanded={expand} onChange={() => setExpand(!expand)}>
			<AccordionSummary
				className='filter-accordion-summary'
				expandIcon={<ExpandMoreIcon />}
			>
				<legend className='h4-styled'>{props?.filterTitle} <span className={selectedFilters?.length === 0 ? 'disabled-text' : ''}>{`(${selectedFilters?.length})`}</span></legend>
			</AccordionSummary>
			<AccordionDetails className='filter-accordion-details'>
				<div>
					{
						filterOptions?.options?.length >= 8 &&
						<>
							<div className={searchClasses.searchBar}>
								<div className='search-field'>
									<TextField id={`search-${props?.filterType}-text`} value={searchValue} onChange={onChange} />
									<div className='search-field-actions'>
										<svg aria-hidden='true' focusable='false'>
											<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#search-icon' />
										</svg>
									</div>
								</div>
								<p className='caption grey-text'>{props?.filterHelperText}</p>
							</div>

						</>
					}
					<div className={filterOptions?.options?.length >= 8 ? 'show-scroll' : ''}>
						{

							displayedOptions?.map(option =>
								<div key={option?.value}>
									<FormControlLabel
										key={option?.value}
										label={option?.display}
										control={
											<Checkbox
												value={option?.value}
												checked={checked[option?.value] || false}
												onChange={(evt) => handleChange(evt, option?.value, option?.display)}
												inputProps={{ 'aria-label': 'controlled' }}
											/>
										}
									/></div>)

						}
					</div>
				</div>
			</AccordionDetails>
		</Accordion>
	);
}


CheckBoxFilter.defaultProps = {
	expand: true,
};